import { render, staticRenderFns } from "./zlfList.vue?vue&type=template&id=4d64bd25&scoped=true"
import script from "./zlfList.vue?vue&type=script&lang=js"
export * from "./zlfList.vue?vue&type=script&lang=js"
import style0 from "./zlfList.vue?vue&type=style&index=0&id=4d64bd25&prod&lang=css"
import style1 from "./zlfList.vue?vue&type=style&index=1&id=4d64bd25&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d64bd25",
  null
  
)

export default component.exports